<div class="td-wb-checkbox"
     [class.td-wb-checkbox--reverse]="labelOnTheLeft()"
     [class.td-wb-checkbox--toggle]="toggleStyle()">
  <input type="checkbox"
         class="td-wb-checkbox__input"
         [attr.id]="finalCheckboxId()"
         [attr.role]="(toggleStyle() ? 'switch' : null)"
         [name]="finalName()"
         [attr.value]="optionValue()"
         [attr.tabindex]="tabIndex()"
         [disabled]="disabled()"
         [attr.aria-label]="ariaLabel()"
         [attr.aria-labelledby]="ariaLabelledBy()"
         [attr.aria-describedby]="ariaDescribedBy()"
         [checked]="checked()"
         (change)="onChange($event)"
         (click)="onInputClick($event)">
  <label class="td-wb-checkbox__label"
         [attr.for]="finalCheckboxId()"
         [attr.aria-hidden]="hasAriaLabel() ? 'true' : null">
    <span class="td-wb-checkbox__tick"
          [class.td-wb-checkbox__tick--center]="selectorPosition() === 'center'"></span>
    <span class="td-wb-checkbox__label-content"
          [class.td-wb-checkbox__label-content--left]="labelOnTheLeft()"
          [class.td-wb-checkbox__label-content--full]="isFullWidth()">
      <ng-content />
    </span>
  </label>
</div>



